import { useToggleState } from '@cian/react-utils';
import { pipe } from 'ramda';
import * as React from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';

import { BannerLayout } from '../../components/BannerLayout';
import { ELeaveContactsSendFrom } from '../../types/promoInfo/leaveContacts';
import { LeaveContactsFormModalContainer } from '../LeaveContactsFormModalContainer';
import { trackSignupForMasterclassBannerClick } from './tracking';

export const SignupForMasterclassSection = () => {
  const deviceType = useDeviceType();

  const { toggle: toggleIsModalOpen, state: isModalOpen } = useToggleState();

  return (
    <>
      <BannerLayout
        imageX1="https://cdn.cian.site/frontend/e2e-form-assets/promo/images/signup_for_masterclass_x1.png"
        imageX2="https://cdn.cian.site/frontend/e2e-form-assets/promo/images/signup_for_masterclass_x2.png"
        description="Проводим бесплатное обучение и раскрываем все особенности"
        action={
          <Button
            onClick={pipe(trackSignupForMasterclassBannerClick, toggleIsModalOpen)}
            fullWidth={deviceType !== 'desktop'}
            size="L"
          >
            Записаться на мастер-класс
          </Button>
        }
      />
      <LeaveContactsFormModalContainer
        onClose={toggleIsModalOpen}
        open={isModalOpen}
        sentFrom={ELeaveContactsSendFrom.B2bMasterClass}
      />
    </>
  );
};
